import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-10 text-center text-gray-500"
}
const _hoisted_2 = {
  key: 1,
  class: "p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm"
}
const _hoisted_3 = {
  key: 2,
  class: "space-y-4 text-sm"
}
const _hoisted_4 = { class: "grid grid-cols-2 gap-x-4 gap-y-2 text-gray-700" }
const _hoisted_5 = { class: "font-mono text-xs" }
const _hoisted_6 = { class: "break-all" }
const _hoisted_7 = { class: "col-span-1 whitespace-pre-wrap break-words" }
const _hoisted_8 = { class: "font-medium text-gray-900" }
const _hoisted_9 = { class: "flex flex-wrap justify-end gap-2 pt-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_12 = {
  key: 1,
  class: "fas fa-sign-in-alt mr-1"
}

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ModalComp } from '@/components'
import { adminEfpClearImpersonation } from '@/api/adminEfp'
import { useAdminEfpStore } from '@/stores/adminEfp'
import { useAuthStore } from '@/stores/auth'
import type { AdminEfpVendeurDetails } from '@/api/adminEfp'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminVendeurAccountModal',
  props: {
    isVisible: { type: Boolean },
    vendeurId: {}
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()
const adminEfp = useAdminEfpStore()
const authStore = useAuthStore()

const details = ref<AdminEfpVendeurDetails | null>(null)
const detailsLoading = ref(false)
const detailsError = ref('')
const accessLoading = ref(false)

function formatDateInscription(value?: string | null): string {
  if (!value) return '—'
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('fr-FR')
}

async function loadDetails(idVendeur: number) {
  details.value = null
  detailsError.value = ''
  detailsLoading.value = true
  try {
    details.value = await adminEfp.getVendeurDetails(idVendeur)
  } catch (e) {
    detailsError.value = e instanceof Error ? e.message : 'Erreur de chargement'
  } finally {
    detailsLoading.value = false
  }
}

async function accessAccount() {
  const d = details.value
  if (!d) return
  const popup = window.open('about:blank', '_blank')
  accessLoading.value = true
  detailsError.value = ''
  try {
    await adminEfpClearImpersonation()
    const { ok, adminDisplayName } = await adminEfp.impersonate(d.id_vendeur)
    if (!ok) throw new Error('Impersonation impossible')
    authStore.setImpersonationFromCookie(true, adminDisplayName ?? undefined)
    const dashboardUrl = router.resolve('/dashboard').href
    if (popup) {
      popup.opener = null
      popup.location.href = dashboardUrl
    } else {
      window.location.href = dashboardUrl
    }
    emit('update:isVisible', false)
  } catch (e) {
    popup?.close()
    detailsError.value = e instanceof Error ? e.message : 'Impersonation impossible'
  } finally {
    accessLoading.value = false
  }
}

watch(
  () => [props.isVisible, props.vendeurId] as const,
  ([visible, idVendeur]) => {
    if (visible && idVendeur) {
      void loadDetails(idVendeur)
      return
    }
    details.value = null
    detailsError.value = ''
    accessLoading.value = false
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalComp), {
    "is-visible": _ctx.isVisible,
    title: "Compte grossiste",
    size: "lg",
    "hide-footer": "",
    "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      (detailsLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl mb-3" }, null, -1),
            _createElementVNode("p", null, "Chargement…", -1)
          ])))
        : (detailsError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(detailsError.value), 1))
          : (details.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("dl", _hoisted_4, [
                  _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-gray-500" }, "ID vendeur", -1)),
                  _createElementVNode("dd", _hoisted_5, _toDisplayString(details.value.id_vendeur), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "text-gray-500" }, "Statut eFashion", -1)),
                  _createElementVNode("dd", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(
                details.value.statutEfashion === 'Validé' ||
                details.value.statutEfashion === 'Actif'
                  ? 'text-green-700 font-medium'
                  : 'text-amber-700 font-medium'
              )
                    }, _toDisplayString(details.value.statutEfashion), 3)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "text-gray-500" }, "Statut du compte", -1)),
                  _createElementVNode("dd", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(
                details.value.statutCompte === 'En ligne'
                  ? 'text-green-700 font-medium'
                  : 'text-amber-700 font-medium'
              )
                    }, _toDisplayString(details.value.statutCompte), 3)
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "text-gray-500" }, "Date d'inscription", -1)),
                  _createElementVNode("dd", null, _toDisplayString(formatDateInscription(details.value.dateInscription)), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("dt", { class: "text-gray-500" }, "Prénom", -1)),
                  _createElementVNode("dd", null, _toDisplayString(details.value.prenomContact || '—'), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "text-gray-500" }, "Nom", -1)),
                  _createElementVNode("dd", null, _toDisplayString(details.value.nomContact || '—'), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("dt", { class: "text-gray-500" }, "Email", -1)),
                  _createElementVNode("dd", _hoisted_6, _toDisplayString(details.value.email || '—'), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("dt", { class: "text-gray-500" }, "Téléphone", -1)),
                  _createElementVNode("dd", null, _toDisplayString(details.value.telephone || '—'), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("dt", { class: "text-gray-500" }, "Adresse", -1)),
                  _createElementVNode("dd", _hoisted_7, _toDisplayString(details.value.adresse || '—'), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("dt", { class: "text-gray-500" }, "Boutique", -1)),
                  _createElementVNode("dd", _hoisted_8, _toDisplayString(details.value.nomBoutique || '—'), 1),
                  _cache[13] || (_cache[13] = _createElementVNode("dt", { class: "text-gray-500" }, "Société", -1)),
                  _createElementVNode("dd", null, _toDisplayString(details.value.nomSociete || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:isVisible', false)))
                  }, " Fermer "),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: accessLoading.value,
                    class: "px-4 py-2 text-sm rounded-lg font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    onClick: accessAccount
                  }, [
                    (accessLoading.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                      : (_openBlock(), _createElementBlock("i", _hoisted_12)),
                    _createTextVNode(" " + _toDisplayString(accessLoading.value ? 'Connexion…' : 'Accéder à son compte'), 1)
                  ], 8, _hoisted_10)
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})